import ErrorLayout from '../../layouts/ErrorLayout'
import ServerError from './ServerError'

export default ErrorLayout(ServerError)